import { useEffect, useState } from 'react';
import useAuth from 'src/hooks/useAuth';
import v2_actionCheckInadimplencia from 'src/actions/v2/cliente/v2_actionCheckInadimplencia';

const DEFAULT_MESSAGE =
  'Atenção: há pendências financeiras na sua conta. Entre em contato com o suporte para regularizar o acesso.';

export default function useInadimplencia() {
  const { cliente } = useAuth();
  const clienteId = cliente?._id || cliente?.id || cliente?.cliente_id;
  const [ativo, setAtivo] = useState(false);
  const [mensagem, setMensagem] = useState('');

  useEffect(() => {
    if (!clienteId) return;
    let cancelled = false;
    v2_actionCheckInadimplencia(clienteId)
      .then((response) => {
        if (cancelled) return;
        const data = response?.data?.data || {};
        setAtivo(!!data.ativo);
        setMensagem(data.mensagem || '');
      })
      .catch(() => {
        if (!cancelled) setAtivo(false);
      });
    return () => {
      cancelled = true;
    };
  }, [clienteId]);

  return { ativo, mensagem: mensagem || DEFAULT_MESSAGE };
}
